
import { FormGroup, FormControl, FormArray, Validators } from '@angular/forms';


export function getAddContainertypeDtoFormGroup() {
return new FormGroup({
    containertypeId: new FormControl<number | undefined>(undefined, [Validators.required]),
})
;
}
      